//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Styles
//#endregion
//#region Components
//#endregion
//#region Images
//#endregion
//#region Services
import { requestGetUsers } from "services/settings/roleAdmin/aboutRoleAdmin";
//#endregion
//#region Utils
import { TIMEOUT_HIDDEN_TOAST_MESSAGE } from "components/ToastMessage/ToastMessage";
import { INIT_FILTER_FIELDS, RECORDS_BY_PAGE } from "../constants";
//#endregion

/*
newlyAddedOrUpdatedUsers = [
    {
        user,
        changes: null || {
            name
            surname
            category
            role
        }
    }
]
*/
const useUserList = ({
    filterFields, 
    notifications: {
        loadingRequest,
        setToastMessage
    },
    paginator
}) => {
    //#region States
    const [userList, setUserList] = useState(null);
    const [triggerRequest, setTriggerRequest] = useState(true);
    const [newlyAddedOrUpdatedUser, setNewlyAddedOrUpdatedUser] = useState(null);
    const [searchedFilters, setSearchedFilters] = useState({ 
        ...INIT_FILTER_FIELDS,
        page: 0
    });
    //#endregion
    //#region Effects
    const pinningNewUser = () => {
        if (!newlyAddedOrUpdatedUser) return;
        const { userObj } = newlyAddedOrUpdatedUser;
        const newUserList = userList.filter(({ user }) => user !== userObj.user);
        setUserList([{ ...userObj }, ...newUserList]);
    }
    useEffect(pinningNewUser, [newlyAddedOrUpdatedUser]);
    const doRequestForFillingUserList = () => {
        // Disparando petición de carga de la lista de usuarios
        if (!triggerRequest) return;
        setTriggerRequest(false);
        fillUserList();
    }
    useEffect(doRequestForFillingUserList, [triggerRequest]);
    //#endregion
    //#region Functions
    const filtersControlsHaveBeenChanged = () => {
        const { nameSurnameOrUser, categoryId, roleId, creationDate } = filterFields;
        return Boolean(
            nameSurnameOrUser !== searchedFilters.nameSurnameOrUser ||
            roleId !== searchedFilters.roleId ||
            categoryId !== searchedFilters.categoryId || 
            creationDate !== searchedFilters.creationDate
        );
    }
    const fillUserList = async messageForToast => {
        loadingRequest.show();
        // Realizando petición
        const newPage = filtersControlsHaveBeenChanged() ? 1 : paginator.data.currentPage;
        const result = await requestGetUsers({
            page: paginator.data.currentPage,
            ...filterFields
        });
        setSearchedFilters({
            nameSurnameOrUser: filterFields.nameSurnameOrUser,
            roleId: filterFields.roleId,
            categoryId: filterFields.categoryId,
            creationDate: filterFields.creationDate,
            page: newPage
        });
        // Setteando cantidad de páginas
        paginator.setQuantityPages({
            quantityPages: Math.ceil(result.total/RECORDS_BY_PAGE),
            totalRecords: result.total
        });
        // Setteando lista de usuarios
        setUserList(result.users);
        loadingRequest.hide();
        showToastAfterFilledUserList(messageForToast);
    }
    const showToastAfterFilledUserList = message => {
        if (!message) return;
        // Configurando toast de carga exitosa
        const successToast = {
            hidden: false,
            message
        };
        setToastMessage({ ...successToast });
        // Programando cierre automático del toast
        setTimeout(() => {
            successToast.hidden = true;
            setToastMessage({ ...successToast });
        }, TIMEOUT_HIDDEN_TOAST_MESSAGE);
    }
    //#endregion
    return {
        userList: {
            value: userList,
            set: setUserList,
            fill: fillUserList,
            triggerFillRequest: setTriggerRequest,
            newlyAddedOrUpdatedUser: {
                value: newlyAddedOrUpdatedUser,
                set: setNewlyAddedOrUpdatedUser
            }
        },
        searchedFilters
    };
}

export default useUserList;